<greco-simple-dialog [data]="dialogData" class="create-custom-purchase-dialog">
  <greco-checkout-page
    [user]="user"
    [isStaff]="true"
    [variants]="variants"
    [purchasedBy]="billedTo"
    [preventRedirect]="true"
    [applyCoupons]="applyCoupons"
    [openContactInNewTab]="true"
    [onlyTerminals]="onlyTerminals"
    [selectedPaymentMethod]="selectedPaymentMethod"
    (purchaseSuccess)="close(true)"
  ></greco-checkout-page>
</greco-simple-dialog>
